import { kindKeyForTitle } from '../../helpers/tasks/resolveAppointmentKinds';

/** De waarde van de optie 'Anders…': geen soort, vrije tekst. */
const OTHER = '';

/**
 * De titel van een afspraak: een keuzelijst 'Soort' als de organisatie soorten
 * heeft, met 'Anders…' voor een eigen titel; zonder soorten het tekstveld zoals
 * altijd. De gekozen soort wordt de titel (tekst, zodat agenda, mail en export
 * niets merken) én de sleutel `Kind`.
 * AI-CONTEXT: See docs/features/afspraak-soort-en-aanwezigheid-bkb.md
 *
 * @param {object} props
 * @param {string} [props.title] - De huidige titel van de afspraak
 * @param {Array<import('../../helpers/tasks/resolveAppointmentKinds').AppointmentKind>} props.kinds - Uitkomst van `useAppointmentKinds`
 * @param {(next: {Title: string, Kind: string}) => void} props.onChange - Nieuwe titel en soort
 * @returns {JSX.Element}
 */
const AppointmentKindTitle = ({ title = '', kinds, onChange }) => {
    const hasKinds = Array.isArray(kinds) && kinds.length > 0;
    const kindKey = hasKinds ? kindKeyForTitle(kinds, title) : OTHER;
    // Vrije tekst: zonder soorten altijd, met soorten alleen bij 'Anders…'.
    const showText = !hasKinds || kindKey === OTHER;

    const kindHandler = (e) => {
        const key = e.target.value;
        const kind = kinds.find((k) => k.key === key);
        onChange(kind ? { Title: kind.label, Kind: kind.key } : { Title: '', Kind: OTHER });
    };

    return (
        <>
            {hasKinds && (
                <div>
                    <label>
                        <strong>Soort</strong>
                        <select value={kindKey} onChange={kindHandler} className="task-editor-input" aria-label="Soort">
                            {kinds.map((k) => <option key={k.key} value={k.key}>{k.label}</option>)}
                            <option value={OTHER}>Anders…</option>
                        </select>
                    </label>
                </div>
            )}
            {showText && (
                <div>
                    <label>
                        <strong>Titel</strong>
                        {/* Ongecontroleerd veld met defaultValue en opslaan bij blur, zoals
                            de rest van de bewerker: een gecontroleerd veld op zijn eigen
                            waarde verliest de focus bij elke snapshot.
                            AI-CONTEXT: See docs/pitfalls.md#ui-tabletitlecell-onchange-refocus */}
                        <input
                            type="text"
                            key={title}
                            defaultValue={title}
                            onBlur={(e) => onChange({ Title: e.target.value, Kind: OTHER })}
                            required
                            className="task-editor-input"
                            autoComplete="off"
                            aria-label="Titel"
                        />
                    </label>
                </div>
            )}
        </>
    );
};

export default AppointmentKindTitle;
